import { IPagination, IQueryPaginationDto } from './utils';

export class SavedReport {
  reportType: string;
  filters: Record<string, unknown>;
  reportName: string;
  id: string;
  createdAt: string;
  updatedAt: string;
  userId: number;
}

export class SavedReportListResponse extends IPagination {
  results: SavedReport[];
}

export class SavedReportResponse {
  result: SavedReport;
}

export class SavedReportQueryDto extends IQueryPaginationDto {
  reportType?: string;
  reportName?: string;
}
